import { gql, useQuery, useApolloClient } from '@apollo/client';
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Icon, IconBlock,
} from 'anf-core-react';
import ProductPageContext from '../../../contexts/ProductPageContext';

export const getSocialProofing = gql`
query GetCollectionEvents($productIdParam: String!, $eventType: String!, $timeWindow: Int!) {
  collectionEvents(productIdParam: $productIdParam, eventType: $eventType, timeWindow: $timeWindow) {
    eventCount
    eventType
    timeWindow
    message
  }
}
`;

export default function SocialProofingMessage({
  productIdParam,
  eventType = 'views',
  timeWindow = 1440,
  parentBrand,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const { actions } = ProductPageState;
  const client = useApolloClient();
  const { error, loading, data } = useQuery(getSocialProofing, {
    variables: { productIdParam, eventType, timeWindow },
    context: { batch: true },
    fetchPolicy: 'no-cache',
    ssr: false,
    client,
  });
  const flameIconBrand = parentBrand === 'anf' ? 'flame-anf' : 'flame-hco';
  const queryData = data;

  useEffect(() => {
    const eventCount = queryData?.collectionEvents?.eventCount;

    if (eventCount !== undefined && eventCount !== null) {
      actions.setActiveProductHasSocialProofing(eventCount > 1);
    }
  }, [queryData?.collectionEvents?.eventCount, actions]);

  if (error) {
    return null;
  }

  if (loading) {
    return null;
  }

  return (
    queryData.collectionEvents.eventCount > 1
      ? (
        <div className="social-proofing-message fadein">
          <div className=" social-proofing-icon content bump">
            <IconBlock icon={<Icon icon={flameIconBrand} size="s" className="social-proofing-icon" />}>
              <span className="h3">{queryData?.collectionEvents?.message}</span>
            </IconBlock>
          </div>
        </div>
      )
      : null
  );
}

SocialProofingMessage.propTypes = {
  timeWindow: PropTypes.oneOf([1440, 1200, 960, 720, 480, 240, 60, 15]),
  eventType: PropTypes.oneOf(['views', 'atc', 'purchases']),
  productIdParam: PropTypes.string.isRequired,
};
